import InfluencerPage from "./-influencer";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/user/influencer")({
  staticData: {
    menuLabel: "达人管理",
    showInMenu: true,
    menuGroup: "/user",
    menuOrder: 1,
  },
  component: InfluencerPage,
});
